import { render } from "./SchedulerReview.vue?vue&type=template&id=d168b42c&scoped=true"
import script from "./SchedulerReview.vue?vue&type=script&lang=js"
export * from "./SchedulerReview.vue?vue&type=script&lang=js"

import "./SchedulerReview.vue?vue&type=style&index=0&id=d168b42c&lang=scss&scoped=true"

import exportComponent from "/Users/jburnett/Documents/TBA/hockey-scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d168b42c"]])

export default __exports__